/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultNiveau } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_032: Question = {
  id: 'pres-032-programme-suivi-especes-sentinelles',
  oldId: '46',
  title: 'Mise en place d\'un Programme de suivi d’une ou plusieurs espèces sentinelles',
  number: '3.16',
  description: [''],
  type: QuestionType.ACTIVITY,
  frequency: 1,
  idEM: 4,
  slots: [
    {
      type: SlotTypes.NIVEAU,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: true,
      scoringFct: (data: string[]) => parseFloat(data[0]),
      score: '0',
      maxScore: 1,
      help: defaultNiveau,
      unit: SlotUnit.OPTIONS,
    },
  ],
};

const question_pres_032__v3: Question = {
  ...question_pres_032,
  title: 'Mise en œuvre d\'un Programme de suivi d’une ou plusieurs espèces en situation précaire',
  number: '3.6',
};

export const question_pres_032_v2: Question = question_pres_032;
export const question_pres_032_v3: Question = question_pres_032__v3;
